import { STORE_CSRF_TOKEN } from '../constants';

export function storeCsrfToken(token){
  return {
    type: STORE_CSRF_TOKEN,
    data: token
  }
}